import {createStore} from 'vuex'
import modulesPaths from '@moeinmdn/mixitweb-front-modules/src/plugin/store'
import Site from "@/store/Modules/Site";
import ProjectAlpha from "@/store/Modules/ProjectAlpha";
import ProjectHistory from "@/store/Modules/ProjectHistory";
import DnsManager from "@/store/Modules/DnsManager";

export default createStore({
    modules: {
        ...modulesPaths,
        Site,
        ProjectAlpha,
        ProjectHistory,
        DnsManager,
    }
})
